import { MatchPointsContainer } from "./styles";
import { BracketViewPickMatchTeam } from "./BracketViewPickMatchTeam";
import { FlexColumn, FlexRow } from "styles/layout";
import { getStringPick, Pick } from "model/Pickem/Pickem";
import { BracketPickOption } from "model/Bracket/BracketPickOptions";

interface Props {
  matchId: string;
  tournamentId: string;
  picks: { [matchId: string]: Pick };
  matchPoints: { [matchId: string]: number } | undefined;
  pickOptions: BracketPickOption[];
}

export const BracketViewPickMatch = ({
  matchId,
  tournamentId,
  picks,
  matchPoints,
  pickOptions,
}: Props) => {
  const pickedRosterId = getStringPick(picks, matchId);
  const { rosterOneId, rosterTwoId } =
    pickOptions.find((o) => o.matchId === matchId) || {};
  return (
    <FlexRow>
      <FlexColumn>
        <BracketViewPickMatchTeam
          tournamentId={tournamentId}
          rosterId={rosterOneId}
          pickedRosterId={pickedRosterId}
        />
        <BracketViewPickMatchTeam
          tournamentId={tournamentId}
          rosterId={rosterTwoId}
          pickedRosterId={pickedRosterId}
        />
      </FlexColumn>
      <MatchPointsContainer>
        {!!matchPoints ? matchPoints[matchId] ?? 0 : "-"}
      </MatchPointsContainer>
    </FlexRow>
  );
};
